import React, { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { Link, useNavigate } from 'react-router-dom';


export default function OptripScreen(){
    const adminSignin = useSelector((state) => state.adminSignin);
    const { adminInfo } = adminSignin;
    const navigate = useNavigate();

    useEffect(()=> {
        if(!adminInfo){
            navigate("/signin");
        }
    },[adminInfo,navigate]);
    return(
         <div className='row'>
            <div className='button-container col-lg-6 col-md-8 col-sm-10 col-xs-12 mt-10 pt-10 ' >

                {adminInfo.role_edit ? <div className='dis-button' >
                    <Link className='button' to="/admin/optrip/booking"> Booking Scrapper </Link>
                </div> : <></>}
                {adminInfo.role_edit ? <div className='dis-button' >
                    <Link className='button' to="/admin/optrip/booking review"> Booking Review Scrapper </Link>
                </div> : <></>}
                {adminInfo.role_edit ?<div >
                    <Link className='button' to="/admin/optrip/chatgpt"> ChatGPT </Link>
                </div> : <></>}
                {adminInfo.role_edit ?<div >
                    <Link className='button' to="/admin/optrip/amenities"> Amenities Scrapper </Link>
                </div> : <></>}
                {adminInfo.role_edit ?<div className='dis-button' >
                    <Link className='button' to="/admin/optrip/places"> Google Places Scrapper </Link>
                </div> : <></>}
                {adminInfo.role_edit ?<div >
                    <Link className='button' to="/admin/optrip/distance"> Graphhoper Distance </Link>
                </div> : <></>}
                
          </div>
        </div>
    );
}